import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import { useTheme } from '../context/ThemeContext';
import { createAppMuiTheme } from './appMuiTheme';

/**
 * Syncs MUI palette.mode with app light/dark toggle (`ThemeContext` + Tailwind `dark` on `html`).
 * Required for DataGrid/MRT, Autocomplete/Select menus, Dialog, and other MUI portals.
 */
export default function AppMuiThemeProvider({ children }) {
  const { theme } = useTheme();
  const mode = theme === 'dark' ? 'dark' : 'light';
  const muiTheme = useMemo(() => createAppMuiTheme(mode), [mode]);

  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
}
